import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {QuoteSchedulingPage} from '../../../../quotes/quote-scheduling-page'

export const Route = createFileRoute('/_app/quotes/$quoteId/scheduling')({
    component: QuoteSchedulingRoute,
})

function QuoteSchedulingRoute() {
    const {quoteId} = Route.useParams()

    return (
        <Container size="lg" py="xl">
            <QuoteSchedulingPage quoteId={quoteId} />
        </Container>
    )
}
